import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Search from "../../components/Search";
import { Btn, SmallRoundedBtn } from "../../components/button/Btn";
import { AddClassroom, SuccessModal } from "../../components/modal";
import { TableClassroom } from "../../components/Tables";

const Classroom = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [openAddClassroom, setOpenAddClassroom] = useState(false);
  const [classroom, setClassroom] = useState("");
  const [description, setDescription] = useState("");
  const [addMember, setAddMember] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const mockData = [
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
    { name: "Classroom Name", date: "13 May, 2024" },
  ];

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleAddClassroom = () => {
    setOpenAddClassroom(true);
  };

  const handleCloseAddClassroomModal = () => {
    setOpenAddClassroom(false);
  };

  const handleSuccess = () => {
    setSuccessModal(true);
    setOpenAddClassroom(false);
  };

  const closeSuccessModal = () => {
    setSuccessModal(false);
  };

  const navigateToDetails = () => {
    navigate("/classroom/classActivity"); // Adjust the path if needed
  };
  return (
    <>
      <div className="p-6 bg-white rounded-lg shadow-md m-3">
        <div className="flex justify-between items-center mb-4 mr-16">
          <div className="flex items-center gap-8 ">
            <h1 className="text-[20px] font-bold text-[#400167] font-satoshi">
              All Classrooms
            </h1>
            <Search onSearch={handleSearch} />
          </div>
          <Btn onClick={handleAddClassroom}>Add New</Btn>
        </div>
        <TableClassroom
          data={mockData} // Replace this with actual data
          searchTerm={searchTerm}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          onViewDetails={navigateToDetails}
        />
      </div>

      <AddClassroom
        isOpen={openAddClassroom}
        onClose={handleCloseAddClassroomModal}
      >
        <div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSuccess();
            }}
          >
            <div className="flex flex-col mb-6">
              <label className="mb-2 text-[16px] text-[#000] font-satoshi font-semibold">
                Classroom Name
              </label>
              <input
                type="text"
                value={classroom}
                onChange={(ev) => setClassroom(ev.target.value)}
                placeholder="Title"
                className="w-[467px] py-2 px-4 focus:outline-none border border-[#000000] rounded-lg"
              />
            </div>
            {/* Textarea */}
            <div className="flex flex-col mb-4">
              <label className="mb-2 text-[16px] text-[#000] font-satoshi font-semibold">
                Description
              </label>
              <textarea
                value={description}
                onChange={(ev) => setDescription(ev.target.value)}
                placeholder="Description"
                className="w-[467px] py-2 px-4 focus:outline-none border border-[#000000] rounded-lg h-[163px]"
              ></textarea>
            </div>

            <div className="flex flex-col mb-6">
              <label className="mb-2 text-[16px] text-[#000] font-satoshi font-semibold">
                Add Members
              </label>
              <input
                type="text"
                value={addMember}
                onChange={(ev) => setAddMember(ev.target.value)}
                placeholder="Add Members"
                className="w-[467px] py-2 px-4 focus:outline-none border border-[#000000] rounded-lg"
              />
            </div>

            <SmallRoundedBtn type="submit">
              <span>Create Classroom</span>
            </SmallRoundedBtn>
          </form>
        </div>
      </AddClassroom>

      <SuccessModal isOpen={successModal} onClose={closeSuccessModal} />
    </>
  );
};

export default Classroom;
